import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { motion } from 'framer-motion';
import { Box, Button, Column, Typography } from 'seagull';
import { LottiePlayer } from '../../LottiePlayer/LottiePlayer';
import closingScreenAnimation from './closing-screen.json';
import layoutStyles from './ClosingContentMobile.module.scss';
import styles from './ClosingStep.module.scss';
const fadeIn = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1
    }
};
export const ClosingContentMobile = (param)=>{
    let { testIds, t, onComplete } = param;
    return /*#__PURE__*/ _jsxs(Column, {
        className: styles.root,
        testId: testIds.ClosingStepTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx(Box, {
                className: styles.confettiArea,
                testId: testIds.ClosingStepTestIds.ConfettiArea(),
                children: /*#__PURE__*/ _jsx(LottiePlayer, {
                    animationData: closingScreenAnimation,
                    loop: false,
                    autoplay: true,
                    className: styles.confettiLottie
                })
            }),
            /*#__PURE__*/ _jsxs(Column, {
                className: cn(styles.textContent, layoutStyles.textContent),
                children: [
                    /*#__PURE__*/ _jsx(motion.div, _object_spread_props(_object_spread({}, fadeIn), {
                        transition: {
                            duration: 0.6,
                            delay: 0.2
                        },
                        children: /*#__PURE__*/ _jsx(Typography, {
                            variant: "h2",
                            fontFamily: "hero",
                            weight: "bold",
                            skin: "magical",
                            testId: testIds.ClosingStepTestIds.Headline(),
                            children: t.headline()
                        })
                    })),
                    /*#__PURE__*/ _jsx(motion.div, _object_spread_props(_object_spread({}, fadeIn), {
                        transition: {
                            duration: 0.6,
                            delay: 0.4
                        },
                        children: /*#__PURE__*/ _jsx(Typography, {
                            variant: "h6",
                            className: styles.description,
                            testId: testIds.ClosingStepTestIds.Description(),
                            children: t.description()
                        })
                    }))
                ]
            }),
            /*#__PURE__*/ _jsx(motion.div, _object_spread_props(_object_spread({
                className: cn(styles.ctaWrapper, layoutStyles.ctaWrapper)
            }, fadeIn), {
                transition: {
                    duration: 0.6,
                    delay: 0.6
                },
                children: /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'complete_onboarding_mobile'
                    },
                    skin: "primary",
                    onClick: onComplete,
                    className: cn(styles.ctaButton, layoutStyles.ctaButton),
                    testId: testIds.ClosingStepTestIds.CtaButton(),
                    children: t.cta()
                })
            }))
        ]
    });
};
